import { render } from "./view-tasks.vue?vue&type=template&id=021f43c5"
import script from "./view-tasks.vue?vue&type=script&lang=js"
export * from "./view-tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__